import CompanyLogo from './CompanyLogo.component';

export default CompanyLogo;
